module.exports = __webpack_public_path__ + "img/product-preview-17.66648fa.png";